import { SR_API_ACTION_GET_LISTING_LIST } from 'api/actionTypes';

export default async function getMoreListingsCount({ state, apiClient }) {
  const viewMoreCount = state.get(['listings', 'viewMoreCount']);

  if (typeof viewMoreCount === 'number') {
    return;
  }

  const params = {
    page: 0,
    count: 1,
    filters: {
      ...state.get(['currentUser', 'searchFilters']),
      locationPoint: state.get(['markets', 'currentUserMarket', 'serviceZone', 'coordinates']),
    },
    onlyCount: true,
  };

  await apiClient.postWithState({
    action: SR_API_ACTION_GET_LISTING_LIST,
    state: state,
    queryId: 'viewMoreCount',
    payload: params,
    onSuccess({ total }) {
      state.set(['listings', 'viewMoreCount'], total);
    },
  });
}
